<mat-card class="confirmation-card">
  <mat-card-header>
    <mat-card-title class="confirmation-title">
      Thank you for submitting your feedback!
    </mat-card-title>
  </mat-card-header>

  <mat-card-content>
    <div class="confirmation-message">
      <p>
        If there is anything further we can help you with, <br />
        please call <a href="tel:1800994412"><b>1800 994 412</b></a
        >.
      </p>
    </div>
  </mat-card-content>
</mat-card>
